<script setup lang="ts">
import { setLocale } from '@/composables/useLocales';
import { onBeforeMount } from 'vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import AppToasts from '@/components/AppToasts.vue';

onBeforeMount(() => {
    setLocale();
});
</script>

<template>
    <div
        id="contracts-app-root"
        class="h-100"
    >
        <RouterView />
        <ConfirmationDialog />
        <AppToasts />
    </div>
</template>
